import { gql } from "@apollo/client"

const DEMAND_LIST_FRAG = gql`
  fragment DemandListFrag on DemandType {
    id
    date
    name
    isLive
    isVerified
    dateTill
    broadcastTime
    varietyGroup {
      id
      name
      codename
    }
    inwardedQuantity
    priceSummary {
      minPrice
      avgPrice
      maxPrice
    }
    variety {
      id
      name
      commodity {
        id
        name
      }
    }
    depot {
      id
      name
    }
    gradePrices {
      id
      grade {
        id
        name
      }
      price
      priceLimit
      priceUnit {
        id
        name
      }
      isDefault
    }
    timeSlots {
      id
      timeSlot {
        id
        name
        fromTime
        toTime
      }
      bookedQuantity
      quantity
      quantityUnit {
        id
        name
      }
    }
  }
`

export { DEMAND_LIST_FRAG }
